import {LastCallError} from './LastCallError.js'

export class CreateLastCallError extends LastCallError {
  constructor({message}) {
    super({message})
  }
}
